import './component-hooks';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@/scss/index.scss';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
// @ts-ignore
import ZoomOnHover from 'vue-zoom-on-hover';
import VueCurrencyInput from 'vue-currency-input';
import VueGtag from 'vue-gtag';

Vue.use(VueCurrencyInput, {
  globalOptions: { locale: 'en-AU', currency: 'AUD', valueAsInteger: true },
});

Vue.use(ZoomOnHover);

Vue.use(VueGtag, {
  config: { id: 'UA-129429482-6' },
  enabled: true,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
